import { isAndroid, isiOS } from '@/h5/utils/browserInfo'
import { getAndroidBridgeInterface } from '@/packages/plugins/appUAConfig'

// export interface AppBridgeMessageType {
//   method: string // 方法名 getUid、getLogInfo
//   data: {
//     type?: number //  1: 打开登录页  2: 跳转充值
//     title?: string
//     eventId?: string // 统计点需求定义的事件id（名称）
//     'event_source'?: string // 来源 默认H5
//     page?: string // 统计点所在的页面名称
//     uploadFlag?: number // 0 不上报, 1 上报到SLS, 2 上报到SLS和第三方统计平台（友盟、趣丸等，不包括归因平台）（未来可能的3：上报到SLS、第三方统计平台、归因平台）
//     params?: any
//   }
//   callBack: boolean // 需要客户端回调 不填默认不需要客户端回传
//   module?: AppBridgeMessageModuleType // 模块操作类型: data(数据操作) ui(界面操作)
// }

const AppBridge = (message) => {
  return new Promise((resolve) => {
    if (isAndroid) {
      const androidBridge = getAndroidBridgeInterface()
      if (androidBridge) {
        resolve(androidBridge.jsCallNative(JSON.stringify(message)))
        return
      }
    } else if (isiOS()) {
      if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.jsCallNative) {
        window.webkit.messageHandlers.jsCallNative.postMessage(JSON.stringify(message))
        window.nativeCallback = (value) => {
          resolve(value)
        }
        return
      }
    }
    resolve('')
  })
}

export default AppBridge
